import { Field } from '@kanda-libs/ks-component-ts';
import {
  CALLBACK_VALIDATION,
  FIELD_PROPS,
  TIMEFRAME_VALIDATION,
} from './constants';

const EnquiryWorkDetailsFormFieldsWorkUrgency: React.FunctionComponent =
  function ({}) {
    return (
      <div className="flex flex-col md:flex-row gap-x-3">
        <Field.Validator validation={TIMEFRAME_VALIDATION}>
          <Field.Select {...FIELD_PROPS.timeframe} />
        </Field.Validator>
        <Field.Validator validation={CALLBACK_VALIDATION}>
          <Field.Select {...FIELD_PROPS.callback} />
        </Field.Validator>
      </div>
    );
  };

export default EnquiryWorkDetailsFormFieldsWorkUrgency;
